import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-update-asp-alert-dialog',
  imports: [
    SharedModule,
    MatDialogModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './update-asp-alert-dialog.component.html',
  styleUrl: './update-asp-alert-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateAspAlertDialogComponent {
  public newPrice = signal<string>('');
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public _data: {
      oldValue: string;
      newValue: {
        ingredientName: string;
        ingredientASP: string;
      };
      isUpdate: boolean;
      regionName: string;
      updatedIngredientASP: string;
      ingredientMapping: boolean;
      nutritionalInfoData: boolean;
      ingrdientId: string;
      countryName: string;
      priceApproverEmail: string;
      sendASPRequest: boolean;
    },
    private _dialogRef: MatDialogRef<UpdateAspAlertDialogComponent>,
  ) {}

  /**
   * Provides the confirmation for updating the ASP price and closes the dialog.
   *
   * @memberof UpdateAspAlertDialogComponent
   * @returns {void}
   */
  public saveUpdatedPrice(): void {
    this._dialogRef.close('confirmed');
  }

  /**
   * Provides the confirmation for send request for the ASP price change and closes the dialog.
   *
   * @memberof UpdateAspAlertDialogComponent
   * @returns {void}
   */
  public sendUpdatedPrice(): void {
    this._dialogRef.close({
      result: 'confirmed',
      newPrice: this.newPrice(),
    });
  }

  /**
   * Provides the Cancellation for updating the ASP price and closes the dialog.
   *
   * @memberof UpdateAspAlertDialogComponent
   * @returns {void}
   */
  public cancelUpdate(): void {
    this._dialogRef.close('cancelled');
  }
}
